import React from "react";
import { Comment, Form, Button, Input } from "antd";
import axios from "axios";
import { withTranslation } from 'react-i18next';

const { TextArea } = Input;

const Editor = ({ onChange, onSubmit, submitting, value, btnText }) => (
    <div>
        <Form.Item>
            <TextArea rows={4} onChange={onChange} value={value} />
        </Form.Item>
        <Form.Item>
            <Button htmlType="submit" loading={submitting} onClick={onSubmit} type="primary">
                {btnText}
            </Button>
        </Form.Item>
    </div>
);

class CommentForm extends React.Component {
    state = ({
        submitting: false,
        value: '',
    });

    componentDidMount() {
        let token = localStorage.getItem('token');
        axios.defaults.xsrfCookieName = 'csrftoken'
        axios.defaults.xsrfHeaderName = "X_CSRFTOKEN"
        axios.defaults.headers = {
            "Content-Type": "application/json",
            "Accept-Language": localStorage.getItem('language'),
            Authorization: `Token ${token}`,
        };
    }

    // handleSubmit = e => {
    //     e.preventDefault();
    //     this.setState({
    //         submitting: true
    //     })
    //     this.props.form.validateFields((err, values) => {
    //         if (!err) {
    //             this.handleFormSubmit(
    //                 values
    //             )
    //             console.log('Received values of form: ', values);
    //         }
    //     });
    // };

    handleSubmit = (event) => {
        const comment_on = this.props.comment_on;

        const postObj = {
            [comment_on]: this.props.data.id,
            comment: this.state.value,
            // datetime: moment().fromNow(),
            //   ...this.state.comments,
        };

        axios.post(process.env.REACT_APP_AXIOS_URL + "/api/comments/create/", postObj)
            .then(res => {
                if (res.status === 201) {
                    this.setState({
                        submitting: false,
                        value: ""
                    })
                    this.props.fetch();
                }
            })
    };

    handleChange = e => {
        this.setState({
            value: e.target.value,
        });
    };


    render() {
        const { value, submitting } = this.state;

        return (
            <div>
                <Comment
                    // avatar={
                    //     <Avatar
                    //         src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
                    //         alt="Han Solo"
                    //     />
                    // }
                    content={
                        <Editor
                            onChange={this.handleChange}
                            onSubmit={this.handleSubmit}
                            submitting={submitting}
                            value={value}
                            btnText={this.props.t('comments.comment_form.add_comment', "Add Comment")}
                        />
                    }
                />
            </div>
        );
    }
}

export default withTranslation()(CommentForm);


// WEBPACK FOOTER //
// ./src/containers/Comments/CommentForm.js